<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="確認"
  >
    <template v-slot:header="{ cancel }">
      <v-card-title class="screen-title">確認</v-card-title>
      <div class="d-flex flex-row align-start ga-2">
        <template v-if="billingFreeFlg">
          <v-chip size="large" color="info" variant="flat">無料枠</v-chip>
        </template>
        <button
          type="button"
          aria-label="Close"
          class="close ml-5"
          @click="cancel()"
        >
          ×
        </button>
      </div>
    </template>
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="pb-3">
              <strong>
                {{ confirmMessage }}
              </strong>
            </v-row>
            <div class="my-3">
              <!-- クラウド設定 -->
              <v-row>
                <v-col>
                  <h3>クラウド設定</h3>
                </v-col>
              </v-row>
              <!--KCPSユーザーID-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="KCPSユーザーID"
                    :value="cloudVnKcpsDetail.cloudVnConnectCommon.serviceKey"
                  />
                </v-col>
              </v-row>
              <!--ロケーション-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ロケーション"
                    :value="
                      $filter.enumTo(
                        cloudVnKcpsDetail.cloudVnConnectCommon.location,
                        'kcpsLocationV2'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--契約番号(M番号)-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="契約番号(M番号)"
                    :value="cloudVnKcpsDetail.cloudVnConnectCommon.mNumber"
                  />
                </v-col>
              </v-row>
              <!--利用ゾーン-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="利用ゾーン"
                    :value="cloudVnKcpsDetail.cloudVnConnectCommon.usageZone"
                  />
                </v-col>
              </v-row>
              <!--接続先仮想ネットワーク（VPN/VN）名-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="接続先仮想ネットワーク(VPN/VN)名"
                    :value="
                      cloudVnKcpsDetail.cloudVnConnectCommon.vpnVnCode.startsWith(
                        'B'
                      )
                        ? cloudVnKcpsDetail.cloudVnConnectCommon.vpnVnCode
                        : cloudVnKcpsDetail.cloudVnConnectCommon.vnName +
                          ':' +
                          cloudVnKcpsDetail.cloudVnConnectCommon.vpnVnCode +
                          '(L3)'
                    "
                  />
                </v-col>
              </v-row>
              <!--プライベートLAN ID-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="プライベートLAN ID"
                    :value="cloudVnKcpsDetail.cloudVnConnectCommon.privateLanId"
                  />
                </v-col>
              </v-row>
              <!--仮想IPアドレス-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="仮想IPアドレス"
                    :value="
                      cloudVnKcpsDetail.cloudVnConnectCommon.virtualIpAddress
                    "
                  />
                </v-col>
              </v-row>

              <!-- VNコネクト設定 -->
              <v-row class="mt-2">
                <v-col>
                  <h3>VNコネクト設定</h3>
                </v-col>
              </v-row>
              <!--品目-->
              <v-row>
                <v-col>
                  <app-label-group label="品目">
                    <template #value>
                      <div class="ml-3">
                        {{
                          cloudVnKcpsDetail.cloudVnConnectCommon.bandwidthType
                        }}({{
                          $filter.bandwidthTo(
                            cloudVnKcpsDetail.cloudVnConnectCommon.bandwidth
                          )
                        }})
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>
              <!--VNコネクト名（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="VNコネクト名(Act)"
                    :value="cloudVnKcpsDetail.cloudVnConnectAct.vnConnectName"
                  />
                </v-col>
              </v-row>
              <!--VNコネクト名（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="VNコネクト名(Sby)"
                    :value="cloudVnKcpsDetail.cloudVnConnectSby.vnConnectName"
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（共通） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(共通)</h3>
                </v-col>
              </v-row>
              <!--ルーティング種別-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ルーティング種別"
                    :value="cloudVnKcpsDetail.cloudVnConnectCommon.routingType"
                  />
                </v-col>
              </v-row>
              <!--AS番号-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="AS番号"
                    :value="cloudVnKcpsDetail.cloudVnConnectCommon.asNumber"
                  />
                </v-col>
              </v-row>
              <!--Maximum Prefix-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Maximum Prefix"
                    :value="
                      cloudVnKcpsDetail.cloudVnConnectCommon.maximumPrefix
                    "
                  />
                </v-col>
              </v-row>

              <!--Connectedルート広報-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Connectedルート広報"
                    :value="
                      $filter.enumTo(
                        cloudVnKcpsDetail.cloudVnConnectCommon.publicRelation,
                        'enable'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <!--BGP 広報ルート(ルート分割)-->
              <v-row>
                <v-col>
                  <app-label-group label="BGP 広報ルート(ルート分割)">
                    <template #value>
                      <div
                        v-if="
                          cloudVnKcpsDetail.cloudVnConnectCommon
                            .publicRelationSplitRouteList?.length
                        "
                        class="d-flex flex-wrap address-scroll"
                      >
                        <span
                          class="ml-3"
                          v-for="(item, index) in cloudVnKcpsDetail
                            .cloudVnConnectCommon.publicRelationSplitRouteList"
                          :key="index"
                        >
                          {{ item }}
                        </span>
                      </div>
                      <span v-else class="ml-3">-</span>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>
              <!--BGP 広報ルート(Connected以外) / (Connected以外のネクストホップ)-->
              <v-row class="mt-2">
                <v-col cols="12">
                  <app-label-group label="BGP 広報ルート(Connected以外)" />
                </v-col>
              </v-row>
              <div class="ml-2">
                <v-row>
                  <v-col cols="6" class="address-title">
                    <app-badge
                      item="LANアドレス"
                      :isRequired="false"
                      :isInfo="false"
                    />
                  </v-col>
                  <v-col cols="6" class="address-title">
                    <app-badge
                      item="ネクストホップアドレス"
                      :isRequired="false"
                      :isInfo="false"
                    />
                  </v-col>
                </v-row>
                <div class="address-scroll d-flex">
                  <div class="w-50 d-flex flex-column">
                    <template
                      v-if="
                        cloudVnKcpsDetail.cloudVnConnectCommon
                          .publicRelationConnectedExceptList?.length
                      "
                    >
                      <span
                        class="ml-3"
                        v-for="(item, index) in cloudVnKcpsDetail
                          .cloudVnConnectCommon
                          .publicRelationConnectedExceptList"
                        :key="index"
                      >
                        {{ item }}
                      </span>
                    </template>
                    <span v-else class="ml-3">-</span>
                  </div>
                  <div class="w-50 d-flex flex-column">
                    <template
                      v-if="
                        cloudVnKcpsDetail.cloudVnConnectCommon
                          .publicRelationNextHopList?.length
                      "
                    >
                      <span
                        class="ml-5"
                        v-for="(item, index) in cloudVnKcpsDetail
                          .cloudVnConnectCommon.publicRelationNextHopList"
                        :key="index"
                      >
                        {{ item }}
                      </span>
                    </template>
                    <span v-else class="ml-5">-</span>
                  </div>
                </div>
              </div>

              <!-- ルーティング情報（Act） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(Act)</h3>
                </v-col>
              </v-row>
              <!--WANアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="WANアドレス"
                    :value="cloudVnKcpsDetail.cloudVnConnectAct.wanAddress"
                  />
                </v-col>
              </v-row>
              <!--ピアIPアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ピアIPアドレス"
                    :value="cloudVnKcpsDetail.cloudVnConnectAct.peerIpAddress"
                  />
                </v-col>
              </v-row>
              <!--プライベートIPアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="プライベートIPアドレス"
                    :value="
                      cloudVnKcpsDetail.cloudVnConnectAct.privateIpAddress
                    "
                  />
                </v-col>
              </v-row>
              <!--Local Preference（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Local Preference"
                    :value="
                      $filter.enumTo(
                        cloudVnKcpsDetail.cloudVnConnectAct.localPreference,
                        'localPreference'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--MED（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="MED"
                    :value="
                      $filter.enumTo(
                        cloudVnKcpsDetail.cloudVnConnectAct.med,
                        'med'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（Sby） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(Sby)</h3>
                </v-col>
              </v-row>
              <!--WANアドレス（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="WANアドレス"
                    :value="cloudVnKcpsDetail.cloudVnConnectSby.wanAddress"
                  />
                </v-col>
              </v-row>
              <!--ピアIPアドレス（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ピアIPアドレス"
                    :value="cloudVnKcpsDetail.cloudVnConnectSby.peerIpAddress"
                  />
                </v-col>
              </v-row>
              <!--プライベートIPアドレス（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="プライベートIPアドレス"
                    :value="
                      cloudVnKcpsDetail.cloudVnConnectSby.privateIpAddress
                    "
                  />
                </v-col>
              </v-row>
              <!--Local Preference（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Local Preference"
                    :value="
                      $filter.enumTo(
                        cloudVnKcpsDetail.cloudVnConnectSby.localPreference,
                        'localPreference'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--MED（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="MED"
                    :value="
                      $filter.enumTo(
                        cloudVnKcpsDetail.cloudVnConnectSby.med,
                        'med'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <template
                v-if="cloudVnKcpsDetail.cloudVnConnectCommon.routeAggregation"
              >
                <!-- カスタム経路集約情報 -->
                <v-row class="mt-2">
                  <v-col>
                    <h3>カスタム経路集約情報</h3>
                  </v-col>
                </v-row>
                <!--経路集約-->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="経路集約"
                      :value="
                        cloudVnKcpsDetail.cloudVnConnectCommon.routeAggregation
                      "
                    />
                  </v-col>
                </v-row>

                <!--注意文言 : 追加確認画面又は変更確認画面のみ表示-->
                <template
                  v-if="
                    cloudVnKcpsDetail.cloudVnConnectCommon.routeAggregation ===
                    'OFF'
                  "
                >
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="WVS2で学習している経路をすべて広報いたします。クラウド側の受信経路上限数を超過している場合は接続ができません。"
                      />
                    </v-col>
                  </v-row>
                </template>

                <!--経路集約アドレス-->
                <v-row v-else>
                  <v-col>
                    <app-label-group label="経路集約アドレス">
                      <template #value>
                        <template
                          v-if="
                            cloudVnKcpsDetail.cloudVnConnectCommon
                              .routeAggregation === 'CUSTOM'
                          "
                        >
                          <div class="d-flex flex-wrap">
                            <span
                              class="ml-3"
                              v-for="(ip, index) in cloudVnKcpsDetail
                                .cloudVnConnectCommon
                                .routeAggregationAddressList"
                              :key="index"
                            >
                              {{ ip }}
                            </span>
                          </div>
                        </template>
                        <template
                          v-else-if="
                            cloudVnKcpsDetail.cloudVnConnectCommon
                              .routeAggregation === 'ON'
                          "
                        >
                          <span class="ml-3">0.0.0.0/0</span>
                        </template>
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
              </template>

              <!--備考-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="備考"
                    :value="
                      $filter.emptyTo(
                        cloudVnKcpsDetail.cloudVnConnectCommon.description,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <template v-if="displayType === 'A'">
                <div class="font-weight-bold mt-5">
                  VNコネクトを追加する前に、以下確認をしてください。
                </div>
                <v-sheet border rounded class="pa-2">
                  <template
                    v-for="(notice, index) in noticeOptions"
                    :key="`${notice.text + index}`"
                  >
                    <v-checkbox
                      v-model="checkedItems"
                      :value="notice.value"
                      :label="notice.text"
                      hide-details
                    />
                  </template>
                </v-sheet>
              </template>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="ok"
              variant="flat"
              color="primary"
              :disabled="
                displayType === 'A'
                  ? !(checkedItems.length === noticeOptions.length)
                  : false
              "
              >はい</v-btn
            >
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CloudVnKcpsDetailV2 } from "@/apis/CloudVnKcpsApi";

export default defineComponent({
  name: "MultiCloudKcps3VnConnectionEditConfirm",
  props: {
    cloudVnKcpsDetail: {
      type: Object as PropType<CloudVnKcpsDetailV2>,
      required: true,
    },
    /** 画面表示モード：
     * A - 追加確認
     * M - 編集確認
     */
    displayType: {
      type: String as PropType<"A" | "M">,
      required: true,
    },
    billingFreeFlg: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
  },
  computed: {
    noticeOptions(): { text: string; value: string }[] {
      if (this.displayType === "A") {
        return [
          {
            text: "VNコネクト作成中はKCPSの設定変更は実施しないこと",
            value: "CHECKED_NOT_CHANGE",
          },
          {
            text: "KCPSユーザーID、利用ゾーン、広報アドレスに誤りがないこと",
            value: "CHECKED_NOT_MISTAKE",
          },
        ];
      }
      return [];
    },
    confirmMessage(): string {
      switch (this.displayType) {
        case "A":
          return "こちらの内容でクラウド接続向けVN回線を追加します。よろしいですか？";
        case "M":
          return "こちらの内容でクラウド接続向けVN回線を変更します。よろしいですか？";
        default:
          throw new Error("wrong displayType!");
      }
    },
  },
  data() {
    return {
      checkedItems: [],
    };
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-checkbox .v-selection-control) {
  min-height: auto;
}
.address-title :deep(.badge-label) {
  font-size: 0.75rem !important;
}
.address-scroll {
  max-height: 107px;
  overflow-y: auto;
}
</style>
